// extracted by mini-css-extract-plugin
export default {"avatar_container":"Avatar_avatar_container__3SHqv","avatar_image":"Avatar_avatar_image__lojOw","avatar_initials":"Avatar_avatar_initials__7J6mE"};